import { Row as RowStyled } from '@lib/core/src/styledComponents/StyledComponents';
import palette from '@lib/core/src/theme/palette';
import { styled, Typography } from '@mui/material';
import { RiStarLine, RiSparklingLine } from '@remixicon/react';

const Row = styled(RowStyled)({
  gap: 4,
  marginBottom: '1vh'
});

export const TemplateText = styled(Typography)({
  fontFamily: 'Reddit Sans',
  fontWeight: 500,
  fontSize: 12,
  color: palette.grey[500]
});

const CapabilitiesTitle = ({ title, isFeatured }: { title: string; isFeatured?: boolean }) => (
  <Row>
    {isFeatured ? (
      <RiStarLine size={16} color={palette.grey[500]} />
    ) : (
      <RiSparklingLine size={16} color={palette.grey[500]} />
    )}
    <TemplateText>{title}</TemplateText>
  </Row>
);

export default CapabilitiesTitle;
